import { Dialog, TextField } from "@mui/material";
import { useState } from "react";
import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";
import { defValueOperacoesCCO, TOperacoesCCO } from "../../types/api/financeiro/conta-corrente-consumo-operacoes";

export default function SelectOperacoesCCO({
    value,
    onChange,
    required = false,
    error = false,
    extraParams
}: SelectSimpleApiQueryProps) {

    const [openModal, setOpenModal] = useState(false)

    const handleClose = () => setOpenModal(false)

    const inputLabel = value ? `${value.id} - ${value.nome}` : ""

    return (
        <>
            <TextField
                {...{ required, error }}
                label={`Operação`}
                variant="outlined"
                fullWidth
                onClick={() => setOpenModal(true)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        setOpenModal(true);
                    }
                }}
                slotProps={{
                    input: { readOnly: true }
                }}
                value={inputLabel}
                helperText={error ? "Campo obrigatório" : ""}
            />

            {
                openModal &&
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        {...{ handleClose, extraParams }}
                        title="Selecionar operação"
                        queryPath="/financeiro/conta-corrente-consumo/pesquisar-operacoes"
                        getItemKey={(item) => item.id}
                        getItemLabel={(item) => `${item.id} - ${item.nome}`}
                        defaultValue={value || defValueOperacoesCCO}
                        onChange={(value) => {
                            onChange(value as TOperacoesCCO)
                            handleClose()
                        }}

                    />
                </Dialog>

            }
        </>
    )
}

interface SelectSimpleApiQueryProps {
    value: TOperacoesCCO
    onChange: (arg: TOperacoesCCO | null) => void
    required?: boolean
    error?: boolean
    extraParams?: { [key: string]: any };
}